<template>

<v-dialog v-model="dialog" width="700px">
  <v-card>
    <p class=".title ma-2">{{hsii.titel }} <v-btn class="mx-10" text icon  @click="rm1Hsii()"><v-icon small>mdi-trash-can-outline</v-icon></v-btn></p>
    <v-form ref="upd1Hsii" v-model="upd1HsiiValid">
    
    <v-row no-gutters>
      <v-col class="ma-2">
       <v-select v-model="indd_nrKeuzesSelected" :items="hsii.indd_nrKeuzes" item-value="indd_nr"  item-text="inddtaal_oms" label="Details" multiple></v-select>
      </v-col>
    </v-row>

     <v-row no-gutters v-for="(iditRecord,i) in hsii.idit_nrKeuzes" :key="i">
      <v-col cols="2" v-if="iditRecord.indi_Keuzes == true" class="ma-2">
       <v-select v-model="iditRecord.indi_aant" :items="iditRecord.indi_aantKeuzes" dense> </v-select>
      </v-col>
      <v-col cols="6" v-if="iditRecord.indi_Keuzes == true" class="ma-2"> 
       <v-select v-model="iditRecord.indi_nr" :items="iditRecord.indi_nrKeuzes" item-value="indi_nr" item-text="inditaal_oms" :label="iditRecord.idittaal_oms" dense> </v-select>
      </v-col>
     </v-row>  
    
    
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="upd1Hsii" :disabled="!upd1HsiiValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      upd1HsiiValid: false,
      huis_encrid: null,
      hsii: {},
      indd_nrKeuzes: [],
      indd_nrKeuzesSelected: []
    }
  },
  methods: {
    open(huis_encrid,hsii_encrid,hsiiDisplay) {
      var deze = this;
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hsii/getHuisToUpd1Hsii.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuisToUpd1Hsii"
          },
          getHuisToUpd1Hsii: {
            huis_encrid: huis_encrid,
            hsii_encrid: hsii_encrid,
            hsiiDisplay: hsiiDisplay
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.hsii = res.data.getHuisToUpd1Hsii;
            this.indd_nrKeuzesSelected = [];
            res.data.getHuisToUpd1Hsii.indd_nrKeuzes.forEach(function(indd) {
            if (indd.selected === 'selected') {
               deze.indd_nrKeuzesSelected.push(indd.indd_nr);
            }
          });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    rm1Hsii() { 
      this.$axios
        .post("ares/json/ares/huis/hsii/rm1Hsii.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "rmd1Hsii"
          },
          rm1Hsii: {
            huis_encrid: this.hsii.huis_encrid,
            hsii_encrid: this.hsii.hsii_encrid,
            hsiiDisplay: this.hsii.hsiiDisplay
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huis/hsii/updHsii/' + res.data.rm1Hsii.huis_encrid + '/' + res.data.rm1Hsii.hsiiDisplay);            
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.rm1Hsii.text,
              color: res.data.rm1Hsii.color
            }); 
            this.dialog = false;
          }
        })
    },
    upd1Hsii() { 
      this.$axios
        .post("ares/json/ares/huis/hsii/upd1Hsii.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "upd1Hsii"
          },
          upd1Hsii: {
            huis_encrid: this.hsii.huis_encrid,
            hsii_encrid: this.hsii.hsii_encrid,
            hsiiDisplay: this.hsii.hsiiDisplay,
            indd_nrKeuzesSelected: this.indd_nrKeuzesSelected,
            indi_nr50: this.hsii.idit_nrKeuzes[0].indi_nr,
            indi_nr50aant: this.hsii.idit_nrKeuzes[0].indi_aant,
            indi_nr100: this.hsii.idit_nrKeuzes[1].indi_nr,
             indi_nr100aant: this.hsii.idit_nrKeuzes[1].indi_aant,
            indi_nr200: this.hsii.idit_nrKeuzes[2].indi_nr,
             indi_nr200aant: this.hsii.idit_nrKeuzes[2].indi_aant,
            indi_nr400: this.hsii.idit_nrKeuzes[3].indi_nr,
             indi_nr400aant: this.hsii.idit_nrKeuzes[3].indi_aant,
            indi_nr500: this.hsii.idit_nrKeuzes[4].indi_nr,
             indi_nr500aant: this.hsii.idit_nrKeuzes[4].indi_aant,
            indi_nr600: this.hsii.idit_nrKeuzes[5].indi_nr,
             indi_nr600aant: this.hsii.idit_nrKeuzes[5].indi_aant,
            indi_nr700: this.hsii.idit_nrKeuzes[6].indi_nr,
             indi_nr700aant: this.hsii.idit_nrKeuzes[6].indi_aant,
            indi_nr999: this.hsii.idit_nrKeuzes[7].indi_nr,
             indi_nr999aant: this.hsii.idit_nrKeuzes[7].indi_aant,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             this.$router.reload('/huis/hsii/updHsii/' + res.data.upd1Hsii.huis_encrid + '/' + res.data.upd1Hsii.hsiiDisplay);            
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.upd1Hsii.text,
              color: res.data.upd1Hsii.color
            }); 
            this.dialog = false;
          }
        })
    }
  }
}
</script>

